import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    CardStyled,
    ContentStyled,
    IconContainerStyled,
    TitleStyled,
    FooterStyled,
    InfoButtonStyled,
} from './styled';
import TooltipDefault from "../TooltipComponent/TololtipDefault";

class ActionCardComponent extends Component {
    render() {
        const {
            icon,
            title,
            variant,
            onClick,
            onInfoClick,
            showInfo
        } = this.props;

        const isDark = variant === 'dark' || variant === 'primary';

        return (
            <CardStyled $isDark={isDark} onClick={onClick}>
                <ContentStyled>
                    <IconContainerStyled>
                        {typeof icon === 'string' &&
                        (icon.startsWith('http') || icon.startsWith('/') || icon.startsWith('data:')) ? (
                            <img src={icon} alt={title}/>
                        ) : (
                            icon
                        )}
                    </IconContainerStyled>
                    <TitleStyled>{title}</TitleStyled>
                </ContentStyled>

                {showInfo && (
                    <FooterStyled>
                        <TooltipDefault text={this.props.infoText}
                                        changePosition={true}
                                        bottom={10}
                                        right={10}/>
                    </FooterStyled>
                )}
            </CardStyled>
        );
    }
}

ActionCardComponent.propTypes = {
    icon: PropTypes.node.isRequired,
    title: PropTypes.string.isRequired,
    variant: PropTypes.oneOf(['light', 'dark', 'primary']),
    onClick: PropTypes.func,
    infoText: PropTypes.string.isRequired,
    showInfo: PropTypes.bool,
};

ActionCardComponent.defaultProps = {
    variant: 'light',
    onClick: () => {
    },
    showInfo: true,
};

export default ActionCardComponent;